import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const VaranasiPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/Varanasi.webp')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Varanasi Spiritual Tour</h1>

            <p className="hero-subtitle">
              3 Nights / 4 Days • Kashi Vishwanath Darshan Package
            </p>

            <div className="hero-price">
              Starting From <span>₹19,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/Varanasi.webp" alt="" />
                <img src="/Images/tour/varanasi2.jpg" alt="" />
                <img src="/Images/tour/varanasi3.webp" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT ENQUIRY FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹19,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Varanasi Spiritual Tour</h1>
              <p>3 Nights / 4 Days • Varanasi Sightseeing</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Kashi Vishwanath Temple Darshan</Col>
                <Col md={6}>✔ Ganga Aarti at Dashashwamedh Ghat</Col>
                <Col md={6}>✔ Sunrise Boat Ride on Ganga</Col>
                <Col md={6}>✔ Sarnath Buddhist Site Visit</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Experience the spiritual energy of Varanasi, the oldest
                living city in the world. Witness sacred rituals,
                divine temples, Ganga Aarti ceremonies and timeless
                traditions along the holy River Ganges.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Varanasi
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival and hotel check-in followed by evening
                    Ganga Aarti at Dashashwamedh Ghat.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Temple & City Tour
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Kashi Vishwanath Temple, Annapurna Temple,
                    Vishalakshi Temple and explore local markets.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Sarnath Excursion
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Sarnath where Lord Buddha delivered his
                    first sermon. Explore museum and stupas.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Early morning boat ride on River Ganga and
                    transfer for onward journey.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Temple Sightseeing</li>
                    <li>Local Transfers</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Puja Charges</li>
                    <li>Insurance</li>
                    <li>Lunch</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/Varanasi.webp" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/varanasi2.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/varanasi3.webp" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default VaranasiPackage;